import React from "react";
import { Button } from "../ui/button";

/**
 * Full-screen modal shown after a successful order. Auto-redirect to "/" is
 * orchestrated by the parent via a setTimeout — see ProdottiPage.jsx.
 */
export const OrderConfirmationModal = ({ open, message, onClose, telegramLink }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 z-[9999] flex items-center justify-center p-4 animate-pulse">
      <div className="bg-white rounded-xl max-w-3xl w-full p-10 shadow-2xl border-8 border-green-500 animate-bounce">
        <div className="text-center">
          <div className="text-9xl mb-8 animate-spin">🎉</div>
          <h2 className="text-4xl font-bold text-green-600 mb-8 uppercase">🎯 ORDINE CONFERMATO! 🎯</h2>

          <div className="bg-gradient-to-r from-green-100 to-blue-100 p-8 rounded-xl text-lg whitespace-pre-wrap border-4 border-green-300 mb-8">
            <div className="text-2xl font-bold text-green-800 mb-4">✅ SUCCESSO TOTALE!</div>
            {message}
          </div>

          <div className="space-y-6">
            {telegramLink && (
              <a
                href={telegramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-[#229ED9] hover:bg-[#1c86b8] text-white text-lg font-bold py-4 rounded-lg shadow-lg"
                data-testid="order-telegram-optin-btn"
              >
                🔔 Ricevi aggiornamenti su Telegram (spedizione e tracking)
              </a>
            )}
            <div className="text-xl font-bold text-gray-800 bg-yellow-100 p-4 rounded-lg border-2 border-yellow-400">
              📧 EMAIL INVIATA! Controlla la tua casella di posta tra qualche minuto
            </div>

            <div className="text-lg text-gray-700 bg-blue-50 p-4 rounded-lg">
              🏪 <strong>Ti ricontatteremo presto per la consegna!</strong><br />
              📞 Tel: +39 347 080 8245<br />
              📧 Email: amm@edicolavillaricca.com
            </div>

            <Button
              onClick={onClose}
              className="w-full bg-green-600 hover:bg-green-700 text-2xl py-6 font-bold uppercase shadow-lg"
              data-testid="order-confirmation-close-btn"
            >
              🎉 PERFETTO! HO RICEVUTO LA CONFERMA 🎉
            </Button>

            <p className="text-sm text-gray-600 bg-gray-100 p-3 rounded">
              ⏰ Tornerai automaticamente alla homepage tra 5 secondi<br />
              💡 Oppure clicca il pulsante sopra per tornare subito
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
